<template>
    <nav class="story__body pages__nav" :aria-labelledby="navTitleId">
        <header data-flex data-flex--justify>
            <h2 :id="navTitleId" class="subtitle"><i role="presentation" />{{ navTitle }}</h2>
        
        <transition appear name="load" mode="out-in">
            <arrow-button
                v-if="$route.params.slug"
                type="prev"
                text="Prev"
                class="screen"
                :label="adjustAriaLabel(this.selected - 1)"
                :disabled="!isPrev"
                @click.native="prev"
            />
        </transition>
            
        <transition appear name="load" mode="out-in">
            <arrow-button
                v-if="$route.params.slug"
                type="next"
                text="Next"
                class="screen"
                :label="adjustAriaLabel(this.selected + 1)"
                :disabled="!isNext"
                @click.native="next"
            />
        </transition>
        
        </header>

        <ul data-flex="row">
            <li v-for="(member, x) in items" :key="`member-${x}`">
            <router-link
                class="nav-link"
                active-class="is-selected"
                :to="{ name: adjustRoute(items[x].slug), params: {
                    slug: items[x].slug
                }}">
                <div>
                    <StoryImage
                        :src="srcset(member.media)"
                        lazy="lazy" className=""
                    />
                    <span class="nav-link__text" v-html="adjustName(member.name)" />
                </div>
            </router-link>
            </li>
        </ul>

    </nav>
</template>

<script>
import StoryImage from '@/components/Story/StoryImage'

export default {
    props: {
        navTitle: String,
        navTitleId: String,
        routeName: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            required: true
        },
    },

    components: {
        StoryImage,
    },

    computed: {
        selected() {
            const x = this.items.findIndex(
                item => item.slug === this.$route.params.slug
            )
            return x
        },
        isPrev() {
            return this.selected > 0
        },
        isNext() {
            return this.selected + 1 < this.items.length
        },
    },

    methods: {
        adjustRoute( slug ) {
            // Get unique route-name for `campus-events`
            return slug.includes('events') 
                ? 'events' 
                : this.routeName
        },
        adjustName( name ) {
            // Get only first name for team members
            return this.routeName === 'member' 
                ? name.split(' ')[0] 
                : name
        },
        adjustAriaLabel( index ) {
            let pretext = 'See'
            
            // Set other pretext for team members
            if ( this.routeName === 'member' ) {
                pretext = 'Meet'
            }

            // Create a label for existing items
            if ( this.items[index] ) {
                const { name } = this.items[index]
                return `${pretext} ${name}`
            }

            return undefined
        },
        srcset( media ) {
            const img = [
                '/static/members/'+ media + '/'+ media +'_Landing.png',
                '/static/members/'+ media + '/'+ media +'_Landing_x2.png'
            ]
            return `${img[0]}`
        },
        prev() {
            if ( !this.isPrev ) return;

            const { slug } = this.items[this.selected - 1]

            this.$router.push({
                name: this.adjustRoute(slug), params: {
                    slug
                }
            })
        },
        next() {
            if ( !this.isNext ) return;
                
            const { slug } = this.items[this.selected + 1]

            this.$router.push({
                name: this.adjustRoute(slug), params: {
                    slug
                }
            })
        },
    },
}
</script>